// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SortGamesButtons_wrapper_3naq3","title":"SortGamesButtons_title_Gz5P_","buttonsContainer":"SortGamesButtons_buttonsContainer_1UKQ9"};